module.exports = __webpack_public_path__ + "static/media/options.554f0c22.svg";